import { createSlice } from '@reduxjs/toolkit';
import { ProfileViewEntity } from '@interpals/api-web';

import { blockUser } from 'redux/profile/actions';
import { logout } from 'redux/auth/actions';
import { markViewsRead } from 'redux/notifications/actions';

import { getGuests, setGuestsLastFetched } from './actions';

export interface GuestsState {
    data?: ProfileViewEntity[];
    lastFetchTimestamp?: number;
}

const initialState: GuestsState = {};

const guestsSlice = createSlice({
    name: 'viewed',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getGuests.fulfilled, (state, { payload }) => {
            state.data = payload;
        });

        builder.addCase(logout.fulfilled, () => {
            return initialState;
        });
        builder.addCase(blockUser.fulfilled, (state, { payload }) => {
            state.data = state.data?.filter((item) => item.user.id !== payload.uid);
        });
        builder.addCase(setGuestsLastFetched, (state, { payload: lastFetched }) => {
            state.lastFetchTimestamp = lastFetched;
        });

        builder.addCase(markViewsRead.fulfilled, (state) => {
            if (state.data) {
                state.data = state.data.map((view) => Object.assign(view, (view.new = false)));
            }
        });
    },
});

export default guestsSlice.reducer;
